import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {ADDPLANACCION, GETALLPLANSACCION, GETPLANACCION, GETPLANACCIONXID, UPDATEPLANACCION} from '../queries/plan.accion.query';
import {PlanAccionModel} from '../models/plan.accion.model';
import {HttpClient} from '@angular/common/http';
import {PATHIMAGENES, PATHLOGIN} from '../../variables';
import {map} from 'rxjs/operators';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {Observable} from 'rxjs';

@Injectable()
export class PlanAccionServices {

  public obsHistoricoPlan: Observable<any>;

  constructor(private apollo: Apollo, private http: HttpClient, private ss: SocketServices) {
    this.obsHistoricoPlan = this.ss.registrarEvento('sendHistoricoPlanAccion');
  }

  updatePlanAccion(pa: PlanAccionModel) {

    let jPlan = JSON.stringify(pa);
    return this.apollo.mutate<any>({
      mutation: UPDATEPLANACCION,
      variables: {
        plan: jPlan
      }
    });
  }

  calcularVentaPerdida(valorIndTienda, ventasEmple, valorIndEmpleado) {

    return (valorIndTienda * ventasEmple) / valorIndEmpleado;
  }


  addPlanAccion(pa: PlanAccionModel) {
    let jPlan = JSON.stringify(pa);
    return this.apollo.mutate<any>({
      mutation: ADDPLANACCION,
      variables: {
        plan: jPlan
      }
    });
  }

  getPlanAccion(empleado: string, semana: string) {

    return this.apollo.query<any>({
      query: GETPLANACCION,
      variables: {
        semana: semana,
        empleado: empleado
      }
    });

  }

  getHistoricoPlanAccion(empleado: string, semana: string) {
    this.ss.enviarEvento('getHistoricoPlanAccion', {empleado: empleado, semana: semana});
  }

  getAllPlanAccion(tiendas: string[]) {
    return this.apollo.query<any>({
      query: GETALLPLANSACCION,
      variables: {
        tiendas: tiendas
      }
    });
  }

  getPlanAccionxID(id: string) {
    return this.apollo.query<any>({
      query: GETPLANACCIONXID,
      variables: {
        id: id
      }
    });
  }

  subirImagen(file: File) {
    const formData: FormData = new FormData();
    formData.append('imagen', file, file.name);
    return this.http.post(PATHIMAGENES, formData).pipe(map((res: any) => res));
  }
}
